import { useEffect, useRef, useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { MenuUsuario } from "../../Usuario/components/MenuUsuario";
import { BannerPanel } from "../../Usuario/components/BannerPanel";
import { Footer } from "../../../components/Landing/Footer";
import { Radio, Button, Modal } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useGestionarJurados } from "../../../hooks/useGestionarJurados";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { juradoEditar } from "../../../redux/actions/juradosAction";
import { openNotification } from "../../../utils/saveFile";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { initialValuesPostulacionModel } from "../../../models/PostulacionesModel/postulacion.model";
import { ModalVisualizarDocumentos } from "../../../components/Generales/ModalVisualizarDocumentos";
import { useDocumentosAdministrativos } from "../../../hooks/useDocumentosAdministrativos";
import ConvocatoriaService from "../../../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "../../../hooks/useEncrypt";
import apiJurados from "../../../api/Jurados/api-jurados";
import { DownloadHTML } from "../../../utils/DownloadFile";
import getStorageUser from "../../../middlewares/GetStorageUser"

export const EstadosFormulariosJurados = () => {
  const { jurado, consultarJurado } = useGestionarJurados();
  const [modal, setModal] = useState(false);
  const [terminosycondiciones, setTerminosyCondiciones] = useState(false);
  const [postulacion, setPostulacion] = useState<any>(initialValuesPostulacionModel);
  const [modalvisualizardocumento, setModalVisualizarDocumento] = useState(false);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  const idJurado = localStorage.getItem('idJurado')
  const idConvocatoriaPostulacion = decrypt(localStorage.getItem("idConvocatoriaPostulacion"))

  const {
    documentos,
  } = useDocumentosAdministrativos();

  const _documentos = localStorage.getItem("documentos") ? JSON.parse(localStorage.getItem("documentos")) : '';

  useEffect(() => {
    consultarJurado(idJurado);
    dispatch(juradoEditar(false));
  }, []);

  const editarFormulario = (url: string) => {
    dispatch(juradoEditar(true));
    switch (url) {
      case "datos_personales":
        navigate("/usuario/Registrarjurado/:estadoFormulario");
        break;
      case "areas_conocimientos":
        navigate("/usuario/categorias/:estadoFormulario");
        break;
      case "agregar_experiencia_jurado":
        navigate("/usuario/agregarExperienciaJurado/:estadoFormulario");
        break;
      case "publicaciones":
        navigate("/usuario/Publicaciones/:estadoFormulario");
        break;
      case "reconocimientos":
        navigate("/usuario/Reconocimientos/:estadoFormulario");
        break;
      case "experiencias_profesionales":
        navigate("/usuario/agregarExperienciaProfesionalJurado/:estadoFormulario");
        break;
      case "educacion_no_formal":
        navigate("/usuario/educacionNoFormal/:estadoFormulario");
        break;
      case "educacion_formal":
        navigate("/usuario/educacionFormal/:estadoFormulario");
        break;
      case "documentos":
        navigate("/usuario/DocumentosAdministrativosJurado/:estadoFormulario");
        break;
      default:
        break;
    }
  };

  const user = getStorageUser()

  const enviarHojaDeVida = async () => {
    try {
      if (terminosycondiciones) {
        const { data: infoConvocatoria } = await ConvocatoriaService.infoConvocatoria(idConvocatoriaPostulacion)
        console.log('infoConvocatoria  -->', infoConvocatoria)
        console.log('area  -->', jurado.areas_conocimientos)

        const storedAreaPrincipalOption = localStorage.getItem("areaPrincipalOption");
        const storedAreasFiltradas = localStorage.getItem("areasFiltradas");
        const tipoConocimiento = localStorage.getItem("tipoConocimiento");
        console.log('storedAreaPrincipalOption  -->', storedAreaPrincipalOption)
        console.log('storedAreasFiltradas  -->', storedAreasFiltradas)
        var json = JSON.parse(storedAreasFiltradas)
        console.log('json  -->', json)
        const { data } = await apiParticipantes.crearPostulacion({
          convocatoria_id: idConvocatoriaPostulacion,
          numero_documento_participante: user.documento,
          nombre_convocatoria: infoConvocatoria[0]?.nombre_convocatoria,
          area: storedAreaPrincipalOption,
          categorias_area: json,
          //categorias_areas: jurado.areas_conocimientos ? jurado?.areas_conocimientos[0]?.areas_conocimientos : [],
          tipo_participante: 1,
          tipo: 2,
          secuencia: infoConvocatoria[0].sec,
          documentos_administrativos: _documentos
        })

        setPostulacion(data)
        setModal(true);
        await apiJurados.enviarHojaVidaJurado(idJurado);
        localStorage.removeItem('documentos')

      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Falta aceptar los terminos y condiciones",
          placement: "bottomRigth",
        });
      }
    } catch (error) {
      return ObjNotificaciones.MSG_ERROR("error", "Falló el registro de tu postulación", "Por favor, inténtalo nuevamente.");
    }
  }
  const componentRef = useRef
    <any>
    ();

  const handlePrint = () => {
    DownloadHTML(componentRef.current);
  }

  const AceptarModal = async () => {
    setModal(false);
    await ObjNotificaciones.MSG_SUCCESS("success", "Te has postulado correctamente");
    return navigate("/usuario/");
  }
  const terminos = () => {
    setModalVisualizarDocumento(true);
  }
  return (
    <>
      <Header />
      <BannerPanel />
      <div className="container-fluid2">
        <div className="row">
          <MenuUsuario activeItem={1} />
          <div className="col-12 col-md-12 col-lg-10">
            <div className="col-12">
              <div className="container-titulo-usuario-logeado">
                <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
                  <span className="font-family-Montserrat-Bold">Hoja de vida</span> Jurado
                </div>
              </div>
            </div>
            <div className="col-12 mt-4">
              <div className="no-margin font-family-Montserrat-Regular font-size-18px">
                <span className="font-family-Montserrat-SemiBold">
                  Genial, estás apunto de postularte como jurado.
                </span>{" "}
                A continuación podrás ver y editar la información completada, o agregar información que falte en la
                hoja de vida.
              </div>
            </div>
            <div className="col-12 mt-4 row-shadow mb-4">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="row"
                      >
                        <div className="col font-family-Montserrat-Semi-Bold font-size-14px">
                          Formulario
                        </div>
                        <div className="col font-family-Montserrat-Semi-Bold font-size-14px">
                          Estado
                        </div>
                        <div className="col-2"></div>
                      </div>
                      <hr className="no-margin" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-items-center align-content-center"
                      >
                        <div className="col  font-family-Montserrat-Regular font-size-12px">
                          Datos personales
                        </div>
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                          Completado
                        </div>
                        <div className="col-2 align-content-center justify-content-flex-end pe-0">
                          <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("datos_personales")}>
                            Editar
                          </Button>
                        </div>
                      </div>
                      <hr className="no-margin" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-items-center align-content-center"
                      >
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          Áreas de conocimiento
                        </div>
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px" />
                          Completado
                        </div>
                        <div className="col-2 align-content-center justify-content-flex-end pe-0">
                          <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("areas_conocimientos")}>
                            Editar
                          </Button>
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12">
                      <div className="row align-items-center align-content-center"
                      >
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          Educación formal
                        </div>
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          {jurado.educacion_formal !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0" >
                          {jurado.educacion_formal !== null ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("educacion_formal")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("educacion_formal")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-items-center align-content-center"
                      >
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          Educación no formal
                        </div>
                        <div className="col font-family-Montserrat-Regular font-size-12px">
                          {jurado.educacion_no_formal !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0" >
                          {jurado.educacion_no_formal !== null ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("educacion_no_formal")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("educacion_no_formal")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-content-center align-items-center"
                      >
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          Experiencia profesional
                        </div>
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          {jurado.experiencias_profesionales !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0" >
                          {jurado.experiencias_profesionales !== null ? (
                            <>
                              <Button
                                className="button-azul-ghost m-2"
                                onClick={(e) => editarFormulario("experiencias_profesionales")}
                              >
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                className="button-azul-ghost m-2"
                                onClick={(e) => editarFormulario("experiencias_profesionales")}
                              >
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-content-center align-items-center"
                      >
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          Experiencia como jurado
                        </div>
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          {jurado.experiencias !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 col-2 justify-content-flex-end pe-0" >
                          {jurado.experiencias !== null ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("agregar_experiencia_jurado")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("agregar_experiencia_jurado")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12">
                      <div
                        className="row align-content-center align-items-center"
                      >
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          Publicaciones
                        </div>
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          {jurado.publicaciones !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px me-2" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0" >
                          {jurado.publicaciones !== null ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("publicaciones")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("publicaciones")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12" >
                      <div
                        className="row align-content-center align-items-center"
                      >
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          Reconocimientos
                        </div>
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          {jurado.reconocimientos !== null ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C me-2 font-size-16px me-2" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario opcional no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0">
                          {jurado.reconocimientos !== null ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("reconocimientos")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("reconocimientos")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                    <div className="col-12" >
                      <div
                        className="row align-content-center align-items-center"
                      >
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          Documentación administrativa
                        </div>
                        <div className="col align-content-center font-family-Montserrat-Regular font-size-12px">
                          {documentos !== null && documentos.length > 0 ? (
                            <>
                              <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                              Completado
                            </>
                          ) : (
                            <span className="font-family-Montserrat-Regular font-size-12px">
                              Formulario obligatorio no agregaste información
                            </span>
                          )}
                        </div>
                        <div className="col-2 justify-content-flex-end pe-0">
                          {documentos !== null && documentos.length > 0 ? (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("documentos")}>
                                Editar
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button className="button-azul-ghost m-2" onClick={(e) => editarFormulario("documentos")}>
                                Agregar
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                      <hr className="m-0" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 mt-4" >
                  <Radio
                    checked={terminosycondiciones}
                    onChange={(e: any) =>
                      setTerminosyCondiciones(e.target.checked)}
                  />
                  <span>Acepto </span>
                  <span className="font-color-051923bf terminos" onClick={terminos}> términos y Condiciones</span>
                </div>
                <div className="col-12 col-md-6 justify-content-flex-end">
                  <Button
                    className="button-azul-radius mb-0"
                    onClick={enviarHojaDeVida}
                  >
                    ENVIAR HOJA DE VIDA
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div>
        <Modal
          style={{ top: 60, zIndex: 3, background: "transparent" }}
          visible={modal}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_verde">
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito
              </div>
            </div>
            <div className="row border-top mt-4 justify-content-flex-center">
              <div className="col-6 justify-content-flex-end">
                <Button
                  className="button-blanco-radius mb-0"
                  onClick={handlePrint}
                >
                  DESCARGAR
                </Button>
              </div>
              <div className="col-6 justify-content-flex-start">
                <Button
                  className="button-azul-radius mb-0"
                  onClick={AceptarModal}
                >
                  ACEPTAR
                </Button>
              </div>
            </div>
          </div>
          <div className="row-shadow mt-2">
            <div className="row">
              <div className="col-12 border-bottom font-family-Montserrat-Regular font-size-14px pb-3">
                Detalles
              </div>
            </div>
            <div
              className="row p-5"
              ref={componentRef}
              style={{ height: "400px", overflowY: "auto" }}
            >
              {/*<div className="row border-bottom">
                <div className="col-12 col-md-6 pt-2 pb-md-2 font-family-Montserrat-Bold">
                  Código radicado:
                </div>
                <div className="col-12 col-md-6 pt-md-2 pb-2">
                  {postulacion.radicado}
                </div>
                </div>*/}
              <div className="row border-bottom">
                <div className="col-12 col-md-6 pt-2 pb-md-2 font-family-Montserrat-Bold">
                  Nombre representante:
                </div>
                <div
                  className="col-12 col-md-6 pt-md-2 pb-2"
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {user.nombres} {user.apellidos}
                </div>
              </div>
              <div className="row border-bottom">
                <div className="col-12 col-md-6 pt-2 pb-md-2 font-family-Montserrat-Bold">
                  Cédula/NIT:
                </div>
                <div
                  className="col-12 col-md-6 pt-md-2 pb-2"
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {user.documento}
                </div>
              </div>
              <div className="row border-bottom">
                <div className="col-12 col-md-6 pt-2 pb-md-2 font-family-Montserrat-Bold">
                  Fecha:
                </div>
                <div
                  className="col-12 col-md-6 pt-md-2 pb-2"
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {postulacion.fecha_creacion}
                </div>
              </div>
              <div className="row border-bottom">
                <div className="col-12 col-md-6 pt-2 pb-md-2 font-family-Montserrat-Bold">
                  Tipo participante:
                </div>
                <div className="col-12 col-md-6 pt-md-2 pb-2">
                  {postulacion.tipo_participante == "1"
                    ? "Persona Natural"
                    : postulacion.tipo_participante == "2"
                      ? "Persona Jurídica"
                      : "Grupo Conformado"}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
      <ModalVisualizarDocumentos
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
        state={{ documento: 'terminosycondiciones.pdf' }}
        tipoDocumento={'terminos'}
      />
    </>
  );
};

